import React from "react";
import { Link } from "react-router-dom";
import { default as DashboardCharts } from "./dashboardChart";
import SubMenuModal from "./Component/SubMenuModal";
import { SUB_MENU, MENU_ITEMS, QUICK_ACTION_ITEMS } from "./constants";

const Dashboard = () => {
  const [showPopup, setShowPopup] = React.useState(false);
  const [subMenu, setSubMenu] = React.useState(SUB_MENU.ATTENDANCE);

  const syncPopupState = React.useCallback(() => {
    const popupState = window.history?.state?.dashboardPopup === true;
    const popupMenu = window.history?.state?.popupMenu || "ATTENDANCE";

    setShowPopup(popupState);
    if (popupState && SUB_MENU[popupMenu]) {
      setSubMenu(SUB_MENU[popupMenu]);
    }
  }, []);

  React.useEffect(() => {
    const onPopState = () => syncPopupState();
    window.addEventListener("popstate", onPopState);
    syncPopupState();

    return () => window.removeEventListener("popstate", onPopState);
  }, [syncPopupState]);

  const closePopup = () => {
    setShowPopup(false);
    const currentState = window.history.state || {};
    window.history.replaceState(
      { ...currentState, dashboardPopup: false, popupMenu: null },
      "",
      window.location.href,
    );
  };

  const openDashboardPopup = (menuLabel) => {
    const menuKey = menuLabel === "Drive" ? "FILE" : menuLabel.toUpperCase();
    const currentState = window.history.state || {};
    const nextState = {
      ...currentState,
      dashboardPopup: true,
      popupMenu: menuKey,
    };

    if (currentState.dashboardPopup !== true) {
      window.history.pushState(nextState, "", window.location.href);
    } else {
      window.history.replaceState(nextState, "", window.location.href);
    }

    setSubMenu(SUB_MENU[menuKey]);
    setShowPopup(true);
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      {/* Division for the menu & action section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 relative">
        {/* Division 1 for the menu */}
        <div className="bg-white shadow-xl rounded-xl p-4 w-full">
          <div className="text-secondary text-xl font-bold text-center mb-4">
            Menu
          </div>
          <div className="flex justify-around items-center">
            {MENU_ITEMS.map(({ label, icon, link, color }) => (
              <div
                key={label}
                className="flex flex-col items-center text-center text-primary hover:text-secondary transition-all cursor-pointer"
                onClick={() => {
                  openDashboardPopup(label);
                }}
              >
                {link ? (
                  <Link to={link} className="flex flex-col items-center">
                    <div
                      className={`w-14 h-14 md:w-16 md:h-16 ${color} bg-opacity-80 rounded-full flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform text-white mb-2`}
                    >
                      {icon}
                    </div>
                    <span className="text-md font-medium">{label}</span>
                  </Link>
                ) : (
                  <>
                    <div
                      className={`w-14 h-14 md:w-16 md:h-16 ${color} bg-opacity-80 rounded-full flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform text-white mb-2`}
                    >
                      {icon}
                    </div>
                    <span className="text-md font-medium"> {label} </span>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* Division 2 for quick actions */}
        <div className="bg-white shadow-xl rounded-xl p-4 w-full">
          <div className="text-secondary text-xl font-bold text-center mb-4">
            Quick Action
          </div>
          <div className="flex justify-around items-center">
            {QUICK_ACTION_ITEMS.map(({ label, icon, link, BillPopUp }) =>
              BillPopUp ? (
                <button
                  key={label}
                  className="flex flex-col items-center text-center text-primary hover:text-secondary transition-all"
                  onClick={() => {
                    openDashboardPopup("Bill");
                  }}
                >
                  {icon}
                  <span className="text-md font-medium">{label}</span>
                </button>
              ) : (
                <Link
                  to={link}
                  key={label}
                  className="flex flex-col items-center text-center text-primary hover:text-secondary transition-all"
                >
                  {icon}
                  <span className="text-md font-medium">{label}</span>
                </Link>
              ),
            )}
          </div>
        </div>

        {/*Division 3 for Adding popup */}

        {showPopup && (
          <SubMenuModal
            subMenuFields={subMenu}
            setShowPopup={closePopup}
            title={subMenu[0].title}
          />
        )}
      </div>
      <div className="w-full">
        <DashboardCharts />
      </div>
    </div>
  );
};

export default Dashboard;
